import { PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { NotificationRequest, Notification } from "../../models/Notification";
import { SearchNotificationsRequest } from "./SearchNotificationsRequest"


const notificationsUrlPrefix: string = "notifications";

export const createNotification = async (notification: NotificationRequest) => {
    return api.post(
        notificationsUrlPrefix,
        notification          
    ) as Promise<void>;
};

export const editNotification = async (notification: NotificationRequest) => {
    return api.put(
        notificationsUrlPrefix,
        notification
    ) as Promise<void>;
};

export const searchNotifications = async(request: SearchNotificationsRequest) => {    
    var result = await (api.get(
        `${notificationsUrlPrefix}/search`,        
        request
    ) as Promise<PagedResult<Notification>>);    
    return result;
};

export const getNotification = async (id: number) => {
    var result = await (api.get(
        `${notificationsUrlPrefix}/${id}`) as Promise<Notification>);
    return result;
};

export const getNotificationsForUser = async () => {
    var result = await (api.get(
        `${notificationsUrlPrefix}/for-user`) as Promise<Notification[]>);
    return result;
};

export const deleteNotification = async (notificationId: number) => {
    var result = await (api.delete(
        `${notificationsUrlPrefix}/${notificationId}`
    ) as Promise<void>);
    return result;
};

